import React from "react";
import { moduleByKey } from "@/modules/registry";
import { Clock, Info } from "lucide-react";

export default function ModuleStub({ moduleKey, title, subtitle, description, note }) {
  const mod = moduleByKey(moduleKey);

  return (
    <div className="p-8 lg:p-14 min-h-full" data-testid={`stub-${moduleKey}-${(title||'').toLowerCase().replace(/\s+/g,'-')}`}>
      <div className="flex flex-wrap items-start justify-between gap-8 animate-fade-up">
        <div>
          <div className="section-eyebrow ink-subtle">{mod?.name}</div>
          <h1 className="mt-4 display-heading text-4xl md:text-5xl ink">{title}</h1>
          {subtitle && <p className="mt-3 ink-muted text-sm max-w-md leading-relaxed">{subtitle}</p>}
        </div>
        <div className="text-right">
          <div className="section-eyebrow">Status</div>
          <div className="mt-3 display-heading text-3xl ink">Coming next</div>
          <div className="mt-1 tiny-label ink-subtle flex items-center justify-end gap-1.5">
            <Clock size={11}/> later phase
          </div>
        </div>
      </div>

      <div className="mt-16 max-w-2xl animate-fade-up animate-fade-up-1">
        <div className="section-eyebrow mb-4">Scope reserved</div>
        <p className="ink-muted leading-relaxed">
          {description || "This module is scaffolded in the platform but the workflows will ship in a later phase. Data models, permissions and audit hooks are already reserved."}
        </p>
        {note && (
          <div className="mt-6 border-l-2 border-foreground/40 pl-4 py-1">
            <div className="tiny-label mb-1 flex items-center gap-1.5"><Info size={11}/> Note</div>
            <div className="text-xs ink-muted leading-relaxed">{note}</div>
          </div>
        )}
      </div>
    </div>
  );
}
